/**
 * Appends the current page search string to a pathname for locale navigation.
 */
export default function pathWithSearch(path: string, search: string): string {
  if (!search) return path;

  const normalizedSearch = search.startsWith('?') ? search : `?${search}`;
  if (normalizedSearch === '?') return path;

  return `${path}${normalizedSearch}`;
}
